import { api } from "../app";
import { dimmer } from "./dimmer";
const defaultContext = $("body");

export const binaryUpload = (uploadParams, context = defaultContext, bustCache = false) => {
	let thumbnail;
	if (uploadParams.thumbnail) {
		thumbnail = uploadParams.thumbnail;
		delete uploadParams.thumbnail;
	}
	const file = uploadParams.file;
	delete uploadParams.file;
	// let's set aside thumbnail details and the
	// binary data for this first part...

	const s3PropertyMap = {
		bucket: "Bucket",
		key: "Key",
		storage: "StorageClass",
		storageClass: "StorageClass",
		cacheControl: "CacheControl",
		tagging: "Tagging"
	};
	for (let prop in uploadParams) {
		if (s3PropertyMap[prop]) {
			uploadParams[s3PropertyMap[prop]] = uploadParams[prop];
			delete uploadParams[prop];
		}
	}
	// convert lazy front-end property names to
	// to S3-compliant keys

	const presignParams = {
		reqId: "6a471fb2-4bed-4668-b688-b5f22687c2f2",
		// s3UploadGetPresignedUrlPvt
		params: uploadParams
	};

	context.append(dimmer());
	return new Promise(async (resolve, reject) => {
		try {
			const response = await $.ajax({
				method: "POST",
				url: `${api}/request`,
				contentType: "application/json",
				xhrFields: {
					withCredentials: true
				},
				data: JSON.stringify(presignParams)
			});
			context.find(".dimmer").remove();
			if (response.success) {
				// have presigned URL, ready to upload data
				const uploadResponse = await $.ajax({
					method: "PUT",
					url: response.data,
					processData: false,
					contentType: false,
					data: file
				});
				let output = "";
				if (thumbnail) {
					const thumbResponse = await $.ajax({
						method: "POST",
						url: `${api}/request`,
						contentType: "application/json",
						xhrFields: {
							withCredentials: true
						},
						data: JSON.stringify({
							reqId: "94813aac-4f69-4176-8240-ce40df81ccf6",
							// ThumbnailInvokePvt
							payload: thumbnail
							// invocationType: "Event"
						})
					});
					if (thumbResponse.success) {
						if (thumbResponse.data.success) {
							output = thumbResponse.data.data;
						} else {
							console.error(thumbResponse.data);
						}
					} else throw thumbResponse.data;
				}
				if (bustCache) {
					try {
						await invalidateCache(bustCache, context);
					} catch (err) {
						throw err;
					}
				}
				resolve(output);
			} else {
				reject(response.data);
			}
		} catch (err) {
			context.find(".dimmer").remove();
			console.error("Error with binary upload request");
			reject(err);
		}
	});
};
// end binaryUpload method

function invalidateCache(params, context = defaultContext) {
	params.reqId = "01074ae2-32bb-4475-8aed-0b4faf6fc493";
	// purgeCloudFrontCachePvt

	params.distroId = params.distroId ? params.distroId : "EIQONYATJLYCL";
	// default distro is gulftreamnews-data

	return new Promise(async (resolve, reject) => {
		try {
			context.append(dimmer());
			const response = await $.ajax({
				method: "POST",
				url: `${api}/request`,
				headers: {
					"Content-Type": "application/json"
				},
				xhrFields: {
					withCredentials: true
				},
				data: JSON.stringify(params)
			});
			context.find(".dimmer").remove();
			if (response.success) {
				resolve("Data cache purged");
			} else {
				throw response.data;
			}
		} catch (err) {
			context.find(".dimmer").remove();
			reject(err);
		}
	});
}
